import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Spacer from '../spacer';
import Text from '../text';
import Button from '../button';
import useMobile from '../hooks/use-mobile';
import Modal from './modal';
const StyledContainer = styled.View`
  padding: ${props => props.mobile ? 20 : 24}px;
`;
const StyledList = styled.View`
  padding-left: 10px;
`;
const StyledItemContainer = styled.View`
  display: flex;
  flex-direction: row;
`;
export default function Instructions(props) {
  const mobile = useMobile();
  const StyledText = mobile ? Text.BodySmall : Text.BodyBase;
  return /*#__PURE__*/React.createElement(Modal, {
    active: props.active,
    activeSetter: props.activeSetter,
    width: mobile ? 300 : 327
  }, /*#__PURE__*/React.createElement(StyledContainer, {
    mobile: mobile
  }, /*#__PURE__*/React.createElement(Text.H6, null, props.title), /*#__PURE__*/React.createElement(Spacer, {
    size: mobile ? 'f4' : 'f8',
    height: true
  }), /*#__PURE__*/React.createElement(StyledText, null, props.label), /*#__PURE__*/React.createElement(Spacer, {
    size: "d16",
    height: true
  }), props.list.map((item, index) => {
    const isLast = props.list.length - 1 === index;
    return /*#__PURE__*/React.createElement(StyledList, {
      key: index
    }, /*#__PURE__*/React.createElement(StyledItemContainer, null, /*#__PURE__*/React.createElement(Text, null, "\u2022"), /*#__PURE__*/React.createElement(Spacer, {
      size: "f8",
      width: true
    }), /*#__PURE__*/React.createElement(StyledText, null, item)), !isLast && /*#__PURE__*/React.createElement(Spacer, {
      size: mobile ? 'f4' : 'f8',
      height: true
    }));
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "d32",
    height: true
  }), /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    width: "100%",
    onPress: props.onPress
  }, props.buttonName)));
}
Instructions.defaultProps = {
  title: '',
  label: '',
  list: [],
  buttonName: '',
  onPress: () => {},
  active: false
};
Instructions.propTypes = {
  title: PropTypes.string,
  label: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.string),
  buttonName: PropTypes.string,
  onPress: PropTypes.func,
  active: PropTypes.bool,
  activeSetter: PropTypes.func.isRequired
};
//# sourceMappingURL=instructions.js.map